import styled from 'styled-components'

export const BulkSelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  width: fit-content;
  cursor: pointer;
`

export const BulkSelectCheckbox = styled.div<{ isChecked: boolean }>`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.isChecked ? '#3D6666' : '#fff'};
  border: 2px solid ${props => props.isChecked ? '#3D6666' : '#C8C8C8'};

  svg {
    width: 100%;
    height: 100%;
  }
`

export const BulkSelectCheckboxLabel = styled.h6`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 900;
  font-size: 14px;
  line-height: 21px;
  color: #7B7C82;
  white-space: nowrap;
`

export const BulkSelectOptionsList = styled.div<{ isOpen?: boolean }>`
  display: ${props => props.isOpen ? 'flex' : 'none'};
  flex-direction: column;
  background: #fff;
  position: absolute;
  top: 85%;
  left: 50%;
  min-width: 120px;
  border: 1px solid #C8C8C8;
  z-index: 100;
`

export const BulkSelectOptionItem = styled.div`
  width: 100%;
  padding: 10px 16px;
  cursor: pointer;
  color: #353744;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  
  &:hover {
    background: #C8C8C8;
  }

`